import { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi"; // hamburger + close icons
import Button from "./Button";
import Logo from "../assets/logo.png";

const Header = ({ handleClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="max-w-7xl mx-auto py-2 px-4 text-center backdrop-blur-md sticky top-0 z-50">
      <div className="flex md:flex-row justify-between items-center border-b-2 border-primary rounded-xl md:py-3 md:px-6 shadow-lg bg-transparent">
        
        {/* Logo */}
        <a href="#home">
          <img src={Logo} alt="logo" className="h-16 md:h-20" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-8 text-lg font-medium text-gray-100">
          <a href="#home" className="hover:text-teal-400 transition-colors">Home</a>
          <a href="#about" className="hover:text-teal-400 transition-colors">About Us</a>
          <a href="#services" className="hover:text-teal-400 transition-colors">Services</a>
          <a href="#contact" className="hover:text-teal-400 transition-colors">Contact</a>
        </nav>

        {/* Button (desktop only) */}
        <div className="hidden md:block">
          <Button variant="whitesolid" onClick={handleClick}>
            GET A CUSTOM QUOTE
          </Button>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="md:hidden text-white text-3xl"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <HiX /> : <HiMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden mt-4 flex flex-col space-y-4 bg-black/80 rounded-lg p-6 text-white font-medium text-lg shadow-lg">
          <a href="#home" onClick={() => setIsOpen(false)} className="hover:text-teal-400">Home</a>
          <a href="#about" onClick={() => setIsOpen(false)} className="hover:text-teal-400">About Us</a>
          <a href="#services" onClick={() => setIsOpen(false)} className="hover:text-teal-400">Services</a>
          <a href="#contact" onClick={() => setIsOpen(false)} className="hover:text-teal-400">Contact</a>

          {/* Button (mobile) */}
          <Button variant="whitesolid" onClick={handleClick}>
            GET A CUSTOM QUOTE
          </Button>
        </div>
      )}
    </div>
  );
};

export default Header;
